import React, { useCallback, useContext, useMemo, useRef, useState } from 'react';
import { RiInformationLine, RiKeyboardLine } from 'react-icons/ri';

import KeyboardShortcutsModal from './KeyboardShortcutsModal';
import ProductDocumentationModal from './ProductDocumentationModal';
import TopbarIconButton from './imageEditor/src/components/Topbar/TopbarIconButton';
import { EditorContext } from './index';
import { isFreeFormBannerMode } from './bannerFrameTypes';

const HELP_ICON_SIZE = 22;

const EditorTopbarHelp = ({
  className = 'respark_topbar-help-buttons',
}) => {
  const { editorConfigContext } = useContext(EditorContext);
  const isFreeFormDocs = useMemo(
    () => isFreeFormBannerMode(editorConfigContext?.type),
    [editorConfigContext?.type],
  );

  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [docsOpen, setDocsOpen] = useState(false);
  const toolbarRef = useRef(null);

  const closeKeyboard = useCallback(() => {
    setKeyboardOpen(false);
  }, []);

  const openDocs = useCallback(() => {
    setKeyboardOpen(false);
    setDocsOpen(true);
  }, []);

  const closeDocs = useCallback(() => {
    setDocsOpen(false);
  }, []);

  const toggleKeyboard = useCallback(() => {
    setDocsOpen(false);
    setKeyboardOpen((current) => !current);
  }, []);

  return (
    <div ref={toolbarRef} className={className}>
      <TopbarIconButton
        className={keyboardOpen ? 'respark_topbar-btn--on' : ''}
        title="Keyboard shortcuts"
        ariaPressed={keyboardOpen}
        onClick={toggleKeyboard}
      >
        <RiKeyboardLine size={HELP_ICON_SIZE} aria-hidden />
      </TopbarIconButton>
      <TopbarIconButton
        className={docsOpen ? 'respark_topbar-btn--on' : ''}
        title="How to make a banner"
        ariaPressed={docsOpen}
        onClick={openDocs}
      >
        <RiInformationLine size={HELP_ICON_SIZE} aria-hidden />
      </TopbarIconButton>
      <KeyboardShortcutsModal open={keyboardOpen} onClose={closeKeyboard} />
      <ProductDocumentationModal
        open={docsOpen}
        onClose={closeDocs}
        isFreeForm={isFreeFormDocs}
      />
    </div>
  );
};

export default EditorTopbarHelp;
